var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var HistoryModalController = /** @class */ (function (_super) {
            __extends(HistoryModalController, _super);
            function HistoryModalController($scope, process, processConfigId, formDataId, propertyId, codeGroupId, rowId, uniqueId, historyService, variableTypeService, processDocumentService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.historyService = historyService;
                _this.variableTypeService = variableTypeService;
                _this.processDocumentService = processDocumentService;
                _this.scope = $scope;
                _this.scope.getValue = function (i) { return _this.getValue(i); };
                _this.scope.processConfigId = processConfigId;
                _this.scope.codeGroupId = codeGroupId;
                _this.scope.process = process;
                if (formDataId) {
                    if (propertyId && rowId) {
                        _this.historyService.getListFormFieldHistory(process.id, formDataId, uniqueId, rowId, propertyId).then(function (items) {
                            $scope.historyItems = items;
                        });
                    }
                    else {
                        _this.historyService.getFormFieldHistory(process.id, formDataId, uniqueId).then(function (items) {
                            $scope.historyItems = items;
                            //add missing history documents to process documents list 
                            _this.addMissingDocumentsToProcessDto();
                        });
                    }
                }
                else {
                    if (propertyId && rowId) {
                        _this.historyService.getListProcessDataHistory(process.id, uniqueId, rowId, propertyId).then(function (items) {
                            $scope.historyItems = items;
                        });
                    }
                    else {
                        _this.historyService.getProcessDataHistory(process.id, uniqueId).then(function (items) {
                            $scope.historyItems = items;
                            //add missing history documents to process documents list 
                            _this.addMissingDocumentsToProcessDto();
                        });
                    }
                }
                return _this;
            }
            HistoryModalController.prototype.addMissingDocumentsToProcessDto = function () {
                var _this = this;
                if (this.scope.historyItems != null && this.scope.historyItems.length > 0) {
                    for (var i = 0; i < this.scope.historyItems.length; i++) {
                        if (this.scope.process && this.scope.process.documents) {
                            if (!this.scope.historyItems[i].document)
                                continue;
                            var match = Enumerable.from(this.scope.process.documents).singleOrDefault(function (x) { return x.id === _this.scope.historyItems[i].document.id; });
                            if (!match) {
                                this.scope.process.documents.push(this.scope.historyItems[i].document);
                                if (this.scope.historyItems[i].document.isSecured) {
                                    this.scope.process.canDownloadSecureDocument[this.scope.historyItems[i].document.id] = this.scope.historyItems[i].canDownloadDocument;
                                }
                            }
                        }
                    }
                }
            };
            HistoryModalController.prototype.getValue = function (item) {
                if (item.variableType === 13 /* Document */) {
                    //return this.processDocumentService.getDocumentById(this.scope.process, item.value);
                    return item.document;
                }
                else {
                    var returnValue = this.variableTypeService.format(item.value, item.variableType);
                    return returnValue;
                }
            };
            return HistoryModalController;
        }(controllers.BaseModalController));
        controllers.HistoryModalController = HistoryModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('HistoryModalController', [
    '$scope', 'process', "processConfigId", 'formDataId', 'propertyId', "codeGroupId",
    'rowId', 'uniqueId', 'historyService', 'variableTypeService', "processDocumentService", 'close'
]);
